/**
 * @fileoverview Workflows section layout (MOR-696, renamed MOR-716)
 *
 * URL: /dashboard/workflows (+ /$templateId)
 *
 * Pure layout shell that renders its child routes via <Outlet />. The manager
 * table lives in the `.index` route and the editor in `.$templateId`, so the
 * editor is NOT nested inside the manager (a parent that rendered the manager
 * directly here would swallow the child route — the missing-<Outlet /> trap).
 *
 * - Convex: tasks.workflows.*
 */
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/_auth/dashboard/_layout/workflows")(
  {
    component: () => <Outlet />,
  },
);
